<template>
  <div>
    <b-form
      :readonly="disabled"
      :actions-disabled="!documentCredentials.$hasChanges"
      :hide-action-buttons="disabled"
      @submit="updateDocument">
      <v-row class="mb-3">
        <v-col cols="12" md="6">
          <b-input
            :model-value="documentSource.uuid"
            hide-details
            disabled
            label="Системний номер"></b-input>
        </v-col>
        <v-col cols="12" md="3">
          <b-input
            :model-value="documentSource.registrationNumber"
            disabled
            hide-details
            placeholder="Не вказано"
            label="Реєстраційний номер"></b-input>
        </v-col>
        <v-col cols="12" md="3">
          <b-input-date
            :model-value="documentSource.registrationDate"
            disabled
            hide-details
            label="Реєстраційна дата"></b-input-date>
        </v-col>
        <v-col cols="12" md="6">
          <b-input
            :model-value="documentSource.docTypeClass?.name || '---'"
            hide-details
            disabled
            label="Клас документа"></b-input>
        </v-col>
        <v-col cols="12" md="6">
          <b-select
            :model-value="documentSource.definition.name"
            disabled
            hide-details
            label="Тип документа"></b-select>
        </v-col>
        <v-col cols="12" md="6">
          <b-select
            v-model="documentCredentials.registrationTypeId"
            :items="
              $directory.get(
                'documentRegistrationTypes',
                documentSource.registrationType
              )
            "
            :readonly="
              !!documentSource.definitionSnapshot?.defaultRegistrationTypeId
            "
            hide-details
            label="Тип реєстрації"
            @focus="$directory.fill('documentRegistrationTypes')"></b-select>
        </v-col>
        <v-col cols="12" md="6">
          <b-select
            v-model="documentCredentials.registrationJournalId"
            :items="
              documentSource.definition?.registrationJournals ||
              [documentSource.journal].filter(Boolean)
            "
            hide-details
            label="Журнал реєстрації"></b-select>
        </v-col>
        <v-col cols="12" md="6">
          <b-input
            :model-value="documentSource.executor?.department?.name || '---'"
            hide-details
            label="Підрозділ"
            disabled></b-input>
        </v-col>
        <v-col cols="12" md="6">
          <b-label label="Виконавець"></b-label>
          <v-menu>
            <template #activator="{ props }">
              <b-input
                :model-value="getPersonName(documentSource.executor)"
                hide-details
                v-bind="props"></b-input>
            </template>

            <employee-list
              style="max-height: 250px"
              @select="
                user => {
                  console.log('user', user)
                  documentSource.executor = {
                    ...user,
                    department: user.departments[0] || null,
                  }
                  documentCredentials.executorId = user.id
                }
              "></employee-list>
          </v-menu>
        </v-col>
        <v-col cols="12" md="6">
          <b-select
            v-model="documentCredentials.accessLevelTypeId"
            :items="
              $directory.get('accessLevelTypes', documentSource.accessLevelType)
            "
            :readonly="
              !!documentSource.definitionSnapshot?.defaultAccessLevelTypeId
            "
            hide-details
            label="Гриф доступу"
            @focus="$directory.fill('accessLevelTypes')"></b-select>
        </v-col>
        <v-col cols="12">
          <b-textarea
            v-model="documentCredentials.description"
            hide-details
            label="Зміст"></b-textarea>
        </v-col>
      </v-row>

      <div v-if="documentSource.fields_snapshot?.length">
        <v-divider class="mb-3"></v-divider>

        <v-row align="center">
          <v-col
            v-for="field in documentSource.fields_snapshot"
            :key="field.fieldDefinitionId"
            cols="12"
            md="6">
            <field-input :field="field"></field-input>
          </v-col>
        </v-row>
      </div>
    </b-form>
  </div>
</template>

<script setup lang="ts">
import FieldInput from './FieldInput.vue'
import EmployeeList from '@/components/inputs/employee-autocomplete/EmployeeList.vue'
import { BForm, BInputDate, BTextarea, BLabel } from 'best-modules/components'
import { useDocument } from '../../document'
import { fillDirectory } from '@/directory'
import { onMounted, watch } from 'vue'
import { getPersonName } from 'best-modules/utils'

fillDirectory(['documentRegistrationTypes', 'accessLevelTypes'])

defineOptions({
  name: 'Requisites',
})

const { documentSource, documentCredentials, disabled, updateDocument } =
  useDocument()

const SEARCHABLE_SOURCES = ['contractors']

const fillEntitySourceDirectories = () => {
  const snapshot = documentSource.fields_snapshot
  if (!snapshot?.length) return

  const sources = [
    ...new Set(
      snapshot
        .map(f => f.entitySource)
        .filter((s): s is string => !!s && !SEARCHABLE_SOURCES.includes(s))
    ),
  ]

  if (sources.length) {
    fillDirectory(sources as any[])
  }
}

onMounted(fillEntitySourceDirectories)
watch(() => documentSource.fields_snapshot, fillEntitySourceDirectories)
</script>
